<mat-button-toggle-group class="button-toggle__button-container"
  (change)="buttonToggled.emit($event.value)"
  [value]="selectedButtonId"
                         [ngClass]="{'button-toggle__button-container-mobile' : isMobile,
                                     'button-toggle__button-container-full-width' : isFullWidth}">
  @for (button of buttons; track button.id) {
    <mat-button-toggle
      class="button-toggle__button"
      [data-testid]="button.name + 'toggle'"
      [attr.data-testid]="button.name + '-button'"
      [disabled]="disabled"
      [value]="button.id">
      {{button.name}}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
